import { Composition, Identity } from "@pdfking/tfunc"

import { CreateColorConvert } from "./CreateColorConvert"
import { HslToRgb } from "./HslToRgb"
import { RgbToCmyk } from "./RgbToCmyk"

/**
 * Converts a Color to a CMYKColor
 * If the input is already CMYK, it will be returned as is
 * If the input is RGB or HSL, it will be converted to CMYK
 */
export const ToCmyk = CreateColorConvert(
  RgbToCmyk,
  Identity,
  Composition(HslToRgb, RgbToCmyk)
)
